import { UpdatePaymentAccountsApi } from "@/features/accounts/payment/scraping/services/update-accounts-api";
import { UpdatePaymentAccountsRequestModel } from "@/features/accounts/payment/scraping/services/update-accounts-model";

/// MoneyLook 口座情報更新処理
export class UpdatePaymentAccountsService {
  private updatePaymentAccountsApi = new UpdatePaymentAccountsApi();

  /**
   * MoneyLook 口座情報更新API実行
   */
  public async updatePaymentAccounts(param: UpdatePaymentAccountsRequestModel) {
    return await this.updatePaymentAccountsApi.updatePaymentAccounts(param);
  }
}